'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _components = require('components');

var _report = require('redux/modules/report');

var reportActions = _interopRequireWildcard(_report);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _downloads = require('helpers/downloads');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var ProjectReportInformation = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    downloadReportLoading: state.report.downloadReportLoading,
    getLinksLoading: state.report.getLinksLoading
  };
}, (0, _extends3.default)({}, reportActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ProjectReportInformation, _Component);

  function ProjectReportInformation() {
    (0, _classCallCheck3.default)(this, ProjectReportInformation);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectReportInformation.__proto__ || (0, _getPrototypeOf2.default)(ProjectReportInformation)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectReportInformation, [{
    key: 'getLinks',
    value: function getLinks() {
      return this.download(this.props.getLinks);
    }
  }, {
    key: 'downloadReport',
    value: function downloadReport() {
      return this.download(this.props.downloadReport);
    }
  }, {
    key: 'download',
    value: function download(method) {
      var _props$reportData$pro = this.props.reportData.project,
          project = _props$reportData$pro === undefined ? {} : _props$reportData$pro;

      return method(project.projectId).promise.then(function (resp) {
        return (0, _downloads.download)('' + _config2.default.app.urlParts.report + resp.data.filePath, resp.data.fileName);
      }).catch(function (err) {
        return err;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          reportData = _props.reportData,
          getLinksLoading = _props.getLinksLoading,
          downloadReportLoading = _props.downloadReportLoading;
      var _reportData$project = reportData.project,
          project = _reportData$project === undefined ? {} : _reportData$project;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.ProjectReportProperty, { title: t('Project'), value: '#' + project.id }),
        _react2.default.createElement(_components.ProjectReportProperty, { title: t('Status'), value: _react2.default.createElement(_components.ProjectStatus, { status: project.status }) }),
        _react2.default.createElement(_components.ProjectReportProperty, { title: t('Manager'), value: project.owName }),
        _react2.default.createElement(
          'div',
          { className: 'text-right margin-top-20' },
          _react2.default.createElement(
            _components.Button,
            { type: 'button', className: 'btn btn-primary', onClick: this.getLinks, loading: getLinksLoading },
            t('Get Links')
          ),
          _react2.default.createElement(
            _components.Button,
            { type: 'button', className: 'btn btn-primary margin-left-20', onClick: this.downloadReport, loading: downloadReportLoading },
            t('Download Report')
          )
        )
      );
    }
  }]);
  return ProjectReportInformation;
}(_react.Component), _class3.propTypes = {
  downloadReport: _propTypes2.default.func,
  downloadReportLoading: _propTypes2.default.bool,
  getLinks: _propTypes2.default.func,
  getLinksLoading: _propTypes2.default.bool,
  reportData: _propTypes2.default.object,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'getLinks', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getLinks'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'downloadReport', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'downloadReport'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = ProjectReportInformation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectReport/ProjectReportInformation.js
// module id = 2055
// module chunks = 1